import { render, staticRenderFns } from "./infoImport.vue?vue&type=template&id=ec95c5fa&scoped=true"
import script from "./infoImport.vue?vue&type=script&lang=js"
export * from "./infoImport.vue?vue&type=script&lang=js"
import style0 from "./infoImport.vue?vue&type=style&index=0&id=ec95c5fa&prod&lang=scss"
import style1 from "./infoImport.vue?vue&type=style&index=1&id=ec95c5fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec95c5fa",
  null
  
)

export default component.exports